import type { RunnerId } from '@ps/isp-web-services-types';

import type { Selection } from '../types';

import { buildBetSlipItemId } from './buildBetSlipItemId';

export const getIsSelectionInBetSlip = (betSlipSelections: Selection[], runnerId: RunnerId) =>
  !!betSlipSelections.find(
    (betSlipSelection) => buildBetSlipItemId(betSlipSelection) === buildBetSlipItemId(runnerId)
  );
